import { render, staticRenderFns } from "./OnlineKassa.vue?vue&type=template&id=aaa48fdc"
import script from "./OnlineKassa.vue?vue&type=script&lang=js"
export * from "./OnlineKassa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports